import FirebaseContext, { withFirebase } from "./context"
import Firebase, { Timestamp, areSameDay } from "./firebase"
import { Reservation, ReservationStatus } from "./Models-dist/reservation"
import { VisitorReservation } from "./Models-dist/visitorReservation"
import { PermanentReservation } from "./Models-dist/permanentReservation"
import { User, UserPriorityLevel, UserPriorityLevelUtils } from "./Models-dist/user"
import { Car, EngineType, allEngineTypes, getEngineTypeIcon } from "./Models-dist/car"
import { allParkingSizes, ParkingSize, ParkingSpot } from "./Models-dist/parkingSpot"
import { AbuseInfo } from "./Models-dist/abuse"
import {
    ApiError,
    ValidationResult,
    DomainValidationResult,
    ReservationResult,
    OccupancyResult,
    ApiErrorCode,
    ReservationResultState,
    FleetReservationResult
} from "./Models-dist/webApi"
import { Location, ReservationType } from "./Models-dist/location"
import { Company } from "./Models-dist/company"
import { Collections, Language } from "./Models-dist/other"
import { FleetReservation } from "./Models-dist/fleetReservation"
import { FleetCar } from "./Models-dist/fleetCar"
import { Fleet } from "./Models-dist/fleet"

export default Firebase

export {
    FirebaseContext,
    withFirebase,
    ApiError,
    ApiErrorCode,
    Timestamp,
    Reservation,
    VisitorReservation,
    User,
    Car,
    EngineType,
    ParkingSpot,
    areSameDay,
    UserPriorityLevel,
    UserPriorityLevelUtils,
    AbuseInfo,
    Location,
    ReservationType,
    ReservationResultState,
    Collections,
    ReservationStatus,
    Language,
    Company,
    PermanentReservation,
    ReservationResult,
    OccupancyResult,
    FleetReservationResult,
    FleetReservation,
    FleetCar,
    Fleet,
    allEngineTypes,
    getEngineTypeIcon,
    ParkingSize,
    allParkingSizes
}
export type { ValidationResult, DomainValidationResult }
